import ApplicantBirthDate from './ApplicantBirthDate';

export default ApplicantBirthDate;
